namespace GeniuzPOS.Member {
    export interface ReportMemberConditionForm {
        MbId: Serenity.LookupEditor;
        MbNameT: Serenity.StringEditor;
        MbNameE: Serenity.StringEditor;
        MbNation: Serenity.StringEditor;
        MbRace: Serenity.StringEditor;
        MbBirthDay: Serenity.DateEditor;
        MbPid: Serenity.StringEditor;
        MbGender: Serenity.LookupEditor;
        MbOccupation: Serenity.StringEditor;
        MbTelNo: Serenity.StringEditor;
        MbEmail: Serenity.StringEditor;
        MbPhoto: Serenity.ImageUploadEditor;
        MbMemo: Serenity.TextAreaEditor;
        MbAddress: Serenity.TextAreaEditor;
        MbTumbol: Serenity.LookupEditor;
        MbAmphur: Serenity.LookupEditor;
        MbProvince: Serenity.LookupEditor;
        MbZipCode: Serenity.StringEditor;
        MbLineAddr1: Serenity.StringEditor;
        MbLineAddr2: Serenity.StringEditor;
        MbLineAddr3: Serenity.StringEditor;
        MbCardStatus: Serenity.RadioButtonEditor;
        MbType: Serenity.LookupEditor;
        MbCardType: Serenity.StringEditor;
        MbApplyDate: Serenity.DateEditor;
        MbExpireDate: Serenity.DateEditor;
        MbAccumPoint: Serenity.DecimalEditor;
        MbNearlyExpirePoint: Serenity.DecimalEditor;
        MbExpirePointDate: Serenity.DateEditor;
    }

    export class ReportMemberConditionForm extends Serenity.PrefixedContext {
        static formKey = 'Member.ReportMemberCondition';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ReportMemberConditionForm.init)  {
                ReportMemberConditionForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.DateEditor;
                var w3 = s.ImageUploadEditor;
                var w4 = s.TextAreaEditor;
                var w5 = s.RadioButtonEditor;
                var w6 = s.DecimalEditor;

                Q.initFormType(ReportMemberConditionForm, [
                    'MbId', w0,
                    'MbNameT', w1,
                    'MbNameE', w1,
                    'MbNation', w1,
                    'MbRace', w1,
                    'MbBirthDay', w2,
                    'MbPid', w1,
                    'MbGender', w0,
                    'MbOccupation', w1,
                    'MbTelNo', w1,
                    'MbEmail', w1,
                    'MbPhoto', w3,
                    'MbMemo', w4,
                    'MbAddress', w4,
                    'MbTumbol', w0,
                    'MbAmphur', w0,
                    'MbProvince', w0,
                    'MbZipCode', w1,
                    'MbLineAddr1', w1,
                    'MbLineAddr2', w1,
                    'MbLineAddr3', w1,
                    'MbCardStatus', w5,
                    'MbType', w0,
                    'MbCardType', w1,
                    'MbApplyDate', w2,
                    'MbExpireDate', w2,
                    'MbAccumPoint', w6,
                    'MbNearlyExpirePoint', w6,
                    'MbExpirePointDate', w2
                ]);
            }
        }
    }
}
